import { withStyles } from 'material-ui/styles';
import React, { Component } from 'react';

import { SelectFormsy, TextFieldFormsy } from '@fuse';
import Formsy from 'formsy-react';
import $ from "jquery";
import { Button, Checkbox, FormControlLabel, MenuItem, Typography } from 'material-ui';

import AddIcon from '@material-ui/icons/Add';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import axios from 'axios';
import Icon from 'material-ui/Icon';
import IconButton from 'material-ui/IconButton';
import { InputAdornment } from 'material-ui/Input';
import Loader from "other-components/loader/loader";
import { withAlert } from 'react-alert';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanel, {
    ExpansionPanelDetails,
    ExpansionPanelSummary,
} from 'material-ui/ExpansionPanel';

const styles = theme => ({

    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64
    },
    tabRoot: {
        height: 64
    },
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    }
});

var employeeGender = [];
var deductionTypeArray = [];
var deductionValueArray = [];
var additionTypeArray = [];
var additionValueArray = [];

// var employeeInsertId = null;

class Tab1GeneralDetails extends Component {

    state = {
        value: 0,
        // inputLinkClicked: false
    };

    constructor(props) {
        super(props);

        this.state = {
            imageURL: 'assets/images/default-avatar.png',
            inputsDedu: ['1'],
            inputsAdd: ['1'],
            loadTitleTypes: [],
            loadEmployementTypes: [],
            loadPaymentTypes: [],
            loadTimeCategoryTypes: [],
            expanded: 'panel1',
            loadDepartmentTypes: [],
            loadDesignationTypes: [],
            loadGreads: [],
            empStatus: true,

            loading: true,
        };

        this.handleUploadImage = this.handleUploadImage.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.removeAttachment = this.removeAttachment.bind(this);

        // loding functions od system
        this.loadEmployeeTitleTypes();
        this.loadEmployementTypes();
        this.loadPaymentTypes();
        this.loadTimeCategoryTypes();
        this.loadDepartmentTypes();
        this.loadDesignationTypes();
        this.loadGreades();
        this.setState({ expanded: 'panel1' });
    }

    resetForm() {

        $("#genaralDetailForm")[0].reset();
        this.setState({ imageURL: 'assets/images/default-avatar.png' });

    }

    removeAttachment() {
        this.setState({ imageURL: 'assets/images/default-avatar.png' });
    }

    // load employee gender into drop-down
    loadEmployeeTitleTypes() {
        this.setState({ loading: true });
        var loadTitleTypes = [];

        axios.get(window.systemServer + '/system/loadTitle')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL")
                    for (let i = 0; i < response.data.result.length; i++) {
                        loadTitleTypes.push({
                            value: response.data.result[i].title,
                        });
                    }
                else
                    for (let i = 0; i < response.data.length; i++) {
                        loadTitleTypes.push({
                            value: response.data[i].title
                        });
                    }
                this.setState({ loadTitleTypes: loadTitleTypes });
                this.setState({ loading: false });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
                this.setState({ loading: false });
            });
    }

    //load employeement types
    loadEmployementTypes() {
        this.setState({ loading: true });
        var loadEmployementTypes = [];

        axios.get(window.systemServer + '/system/loadContarctType')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL")
                    for (let i = 0; i < response.data.result.length; i++) {
                        loadEmployementTypes.push({
                            value: response.data.result[i].contarct_type
                        });
                    }
                else
                    for (let i = 0; i < response.data.length; i++) {
                        loadEmployementTypes.push({
                            value: response.data[i].contarct_type
                        });
                    }
                this.setState({ loadEmployementTypes: loadEmployementTypes });
                this.setState({ loading: false });
            })
            .catch((error) => {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
                this.setState({ loading: false });
            });
    }

    //load payment methos
    loadPaymentTypes() {
        this.setState({ loading: true });
        var loadPaymentTypes = [];

        axios.get(window.systemServer + '/system/loadPaymentType')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL")
                    for (let i = 0; i < response.data.result.length; i++) {
                        loadPaymentTypes.push({
                            value: response.data.result[i].payment_type
                        });
                    }
                else
                    for (let i = 0; i < response.data.length; i++) {
                        loadPaymentTypes.push({
                            value: response.data[i].payment_type
                        });
                    }
                this.setState({ loadPaymentTypes: loadPaymentTypes });
                this.setState({ loading: false });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
                this.setState({ loading: false });
            });
    }

    //load paymet types methos
    loadTimeCategoryTypes() {
        this.setState({ loading: true });
        var loadTimeCategoryTypes = [];

        axios.get(window.systemServer + '/system/loadDurationType')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL")
                    for (let i = 0; i < response.data.result.length; i++) {
                        loadTimeCategoryTypes.push({
                            value: response.data.result[i].duration_type
                        });
                    }
                else
                    for (let i = 0; i < response.data.length; i++) {
                        loadTimeCategoryTypes.push({
                            value: response.data[i].duration_type
                        });
                    }
                this.setState({ loadTimeCategoryTypes: loadTimeCategoryTypes });
                this.setState({ loading: false });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
                this.setState({ loading: false });
            });
    }

    //load department types methos
    loadDepartmentTypes() {
        this.setState({ loading: true });
        var loadDepartmentTypes = [];

        axios.get(window.systemServer + '/system/loadDepartment')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL")
                    for (let i = 0; i < response.data.result.length; i++) {
                        loadDepartmentTypes.push({
                            value: response.data.result[i].department_name
                        });
                    }
                else
                    for (let i = 0; i < response.data.length; i++) {
                        loadDepartmentTypes.push({
                            value: response.data[i].department_name
                        });
                    }
                this.setState({ loadDepartmentTypes: loadDepartmentTypes });
                this.setState({ loading: false });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
                this.setState({ loading: false });
            });
    }

    //load designation types methos
    loadDesignationTypes() {
        this.setState({ loading: true });
        var loadDesignationTypes = [];

        axios.get(window.hrmServer + '/getDesignation')
            .then(response => {
                if (response.data.success) {
                    // alert('Success'+response.data.result[0].DESIGNATION);
                    var designationObj = response.data.result;
                    // console.log("peeen "+employeeObj[31].PROFILE_IMAGE);

                    for (var i = 0; i < designationObj.length; i++) {

                        loadDesignationTypes.push({
                            value: designationObj[i].DESIGNATION
                        });
                    }
                }
                this.setState({ loadDesignationTypes: loadDesignationTypes });
                this.setState({ loading: false });

            }).catch(function (error) {
                // alert(error);
                console.log("designation err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
                this.setState({ loading: false });
            });
    }

    // load greads pending
    loadGreades() {
        this.setState({ loading: true });
        var loadGreads = [];

        axios.get(window.hrmServer + '/getGrades')
            .then(response => {
                if (response.data.success) {
                    var greadeObj = response.data.result;

                    for (var i = 0; i < greadeObj.length; i++) {

                        loadGreads.push({
                            value: greadeObj[i].GREADE_NAME
                        });
                    }
                }
                this.setState({ loadGreads: loadGreads });
                this.setState({ loading: false });

            }).catch(function (error) {
                // alert(error);
                console.log("designation err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
                this.setState({ loading: false });
            });
    }

    // image upload function
    handleUploadImage() {

        const data = new FormData();
        data.append('file', this.uploadInput.files[0]);
        data.append('filename', this.fileName.value);

        console.log("this.this.fileName.value : ", this.fileName.value);
        fetch(window.imageUploadServer + '/upload', {
            method: 'POST',
            body: data,
        }).then((response) => {

            response.json().then((body) => {
                this.setState({ imageURL: window.imageUploadServer + `/${body.file}` });
            });
        });
    }

    handleChange = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    };

    // set employee status into state
    onEmpStatusChanged = ststusE => (event, expanded) => {
        // alert(event.target.checked)
        this.setState({
            empStatus: event.target.checked
        });
    };

    // set gender into state
    onGenderChanged = gen => (event, expanded) => {
        this.setState({
            gender: event.currentTarget.value
        });
    };

    appendInputDedu() {
        // var newInput = `DeductionType-${this.state.inputs.length+1}`;
        var newInputDedu = `${this.state.inputsDedu.length + 1}`;

        var valueOfLastDeductionType = $("#deductionValue" + (newInputDedu - 1)).val();

        if ("" == valueOfLastDeductionType || null == valueOfLastDeductionType || undefined == valueOfLastDeductionType) {
            // alert("Input above Deduction first !");
            this.props.alert.info("Input Above Deduction First !");
        } else {
            this.setState({ inputsDedu: this.state.inputsDedu.concat([newInputDedu]) });
        }
    }

    appendInputAdd() {
        var newInputAdd = `${this.state.inputsAdd.length + 1}`;

        var valueOfLastAddtionType = $("#additionValue" + (newInputAdd - 1)).val();
        // var rmVal = $("#additionValue"+(newInputAdd - 1)).val();
        // alert(rmVal);
        if ("rm" == valueOfLastAddtionType) {
            this.setState({ inputsAdd: this.state.inputsAdd.concat([newInputAdd]) });
        } else {
            if ("" == valueOfLastAddtionType || null == valueOfLastAddtionType || undefined == valueOfLastAddtionType) {
                // alert("Input above Addition first !");
                this.props.alert.info("Input Above Addition First !");
            } else {
                this.setState({ inputsAdd: this.state.inputsAdd.concat([newInputAdd]) });
            }
        }
    }

    // on submit employee personal details
    onSubmit = (model) => {

        this.saveEmployeeDetails(model);

        // this.addhandleClose();
        // window.location.reload();
    };

    // date validation
    dateValidation(date) {
        var noOfYearDigits = (date.split("-")[0]).toString().length
        if (noOfYearDigits == 4) {
            return true;
        } else {
            return false;
        }
    }

    // save employee personal details
    saveEmployeeDetails(model) {

        this.setState({ loading: true });
        // add to array all deduction types and values
        for (var i = 1; i < (this.state.inputsDedu.length + 1); i++) {

            var deductionTypes = model['diductionType' + i];
            var deductionValues = model['deductionValue' + i];
            deductionTypeArray.push(deductionTypes);
            deductionValueArray.push(deductionValues);
        }

        // add to array all addtion types and values
        for (var j = 1; j < (this.state.inputsAdd.length + 1); j++) {
            var addtionTypes = model['additionType' + j];
            var addtionValues = model['addtionValue' + j];
            additionTypeArray.push(addtionTypes);
            additionValueArray.push(addtionValues);
        }

        // add to the object employee grenaral details
        const employeeGenaralDataObj = {
            refNo: model.refNo,
            epfCpf: model.epfCpf,
            title: model.title,
            imageURL: this.state.imageURL,
            lastName: model.lastName,
            firstName: model.firstName,
            middleName: model.middleName,
            nicSsn: model.nicSsn,
            birthday: model.birthday,
            gender: this.state.gender,
            address1: model.address1,
            address2: model.address2,
            city: model.city,
            state: model.state,
            zipCode: model.zipCode,
            countryCode: model.countryCode,
            mobile: model.mobile,
            telephone: model.telephone,
            fax: model.fax,
            email: model.email,
            appoinmentDate: model.appoinmentDate,
            probationPeriod: model.probationPeriod,
            department: model.department,
            designation: model.designation,
            greade: model.greade,
            employeement: model.employeement,
            permentShift: model.permentShift,
            basicSalary: model.basicSalary,
            paymentMethod: model.paymentMethod,
            timeCategory: model.timeCategory,
            timeCategory: model.timeCategory,
            empStatus: this.state.empStatus,
            employeeRoll: model.employeeRoll,

            deductionTypeArray: deductionTypeArray,
            deductionValueArray: deductionValueArray,

            additionTypeArray: additionTypeArray,
            additionValueArray: additionValueArray

        }

        // send to the backend
        if ("none" == model.employeeRoll || "" == model.employeeRoll || undefined == model.employeeRoll || null == model.employeeRoll) {
            this.props.alert.error("Select Employee Role First ");
            this.setState({ loading: false });
        } else {
            if (this.dateValidation(model.birthday) && this.dateValidation(model.appoinmentDate)) {
                axios.post(window.hrmServer + '/saveEmployeeData', employeeGenaralDataObj)
                    .then(res => {

                        if (res.data.success) {

                            console.log(res.data.empId + " Successfully saved employee personal details...");

                            var userProfileObj = {
                                username: model.userName,
                                password: model.password,
                                employeeId: res.data.empId,
                                department: model.department,
                                designation: model.designation,
                                employeeRole: model.employeeRoll,
                                employeeImg: this.state.imageURL,
                                lastName: model.lastName,
                                firstName: model.firstName,
                                middleName: model.middleName,
                            }

                            // call user profile details
                            this.saveUserProfile(userProfileObj);
                            this.setState({ loading: false });
                        } else {
                            // alert('Ivalid Credentials');
                            this.props.alert.error("This NIC number already exists");
                            this.setState({ loading: false });
                        }
                    });
            } else {
                this.props.alert.error("Invalid Date Selection");
                this.setState({ loading: false });
            }

        }
    }

    // save employee user profile
    saveUserProfile(userProfileObj) {

        axios.post(window.authServer + '/access/addUser', userProfileObj)
            .then(res => {

                // alert(res.data.success);
                if (res.data.success) {
                    // alert("Success");
                    this.props.alert.success("New Employee Saved Successfully");

                    $("#genaralDetailForm")[0].reset();
                    this.setState({ imageURL: 'assets/images/default-avatar.png' });
                    this.setState({ loading: false });
                } else {
                    this.setState({ loading: false });
                    this.props.alert.error("Unable to Saved Please Check !");
                }
            });
    }

    // remove addition values when clicked delete button
    removeAllows(val) {
        $('#allow' + val).css('display', 'none');
        $('#additionType' + val).val('rm');
        $('#additionValue' + val).val('rm');
    }

    // remove deduction values when clicked delete button
    removeDeductions(val) {
        $('#dedu' + val).css('display', 'none');
        $('#diductionType' + val).val('');
        $('#deductionValue' + val).val('');
    }

    render() {

        const { classes } = this.props;
        const { value } = this.state;
        const { expanded } = this.state;

        if (this.state.loading) {
            return (

                <Loader />

            );
        } else {

            var alDuStyle = (value) => {
                if (1 == value) {
                    return { marginLeft: 'auto', height: '38px', display: 'none' };
                }
                else {
                    return { display: 'inline-block' };
                }
            };

            return (
                <div className="{classes.root} mt-16">
                    <Formsy
                        id="genaralDetailForm"
                        onValidSubmit={this.onSubmit}
                        onValid={this.enableButton}
                        onInvalid={this.disableButton}
                        ref={(form) => this.form = form}
                        className="flex flex-col justify-center"
                    >
                        <ExpansionPanel expanded={expanded === 'panel1'} onChange={this.handleChange('panel1')}>
                            <ExpansionPanelSummary className="emp-reg-expand-color-1" expandIcon={<ExpandMoreIcon />}>
                                <Typography className="{classes.heading} flex flex-wrap">Personal Details</Typography>
                                {/* <Typography className={classes.secondaryHeading}>I am an expansion panel</Typography> */}
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Typography>
                                    <div className="flex flex-wrap -mx-3 mb-6" style={{ marginLeft: 'auto' }}>

                                        <div className="w-full md:w-1/4  pr-24">
                                            <div className="MuiAvatar-root-915 w-96 h-96  w-full">
                                                <img id="profileImg" src={this.state.imageURL} className="w-96 h-96" />
                                            </div>
                                        </div>

                                        <input accept="image/*" ref={(ref) => { this.uploadInput = ref; }} onChange={this.handleUploadImage} className="{classes.input} invisible" id="icon-button-file" type="file" />


                                        <div>
                                            <input ref={(ref) => { this.fileName = ref; }} value={Date.now()} type="hidden" />
                                        </div>


                                    </div>
                                    <div className="flex flex-wrap -mx-3 mb-6 ">

                                        {/* </div> */}

                                        <div>
                                            <label htmlFor="icon-button-file">
                                                <IconButton color="primary" className="{classes.button} genaral-form-camera-margin" component="span">
                                                    <PhotoCamera />
                                                </IconButton>
                                            </label>
                                        </div>

                                        <div>
                                            <label htmlFor="icon-button-file">
                                                <IconButton
                                                    className="{classes.button} genaral-form-close-margin"
                                                    title="Remove"
                                                    onClick={(ev) => {
                                                        this.removeAttachment();
                                                    }}

                                                >
                                                    <Icon className='text-red'>cancel</Icon>
                                                </IconButton>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="flex flex-wrap -mx-3 mb-6 ">
                                        {/* <div className="w-full md:w-1/6  mt-24"></div> */}
                                        <TextFieldFormsy
                                            className="w-full md:w-1/4   pr-24"
                                            type="text"
                                            name="refNo"
                                            label="Ref.No"
                                        // validations={{
                                        //     required: ""
                                        // }}
                                        // validationErrors={{
                                        //     minLength: 'Min character length is 4'
                                        // }}
                                        // required
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4   pr-24"
                                            type="text"
                                            name="epfCpf"
                                            label="EPF No"

                                            required
                                        />

                                        <SelectFormsy
                                            className="w-full md:w-1/4 mt-16  pr-24"
                                            name="title"
                                            label=""
                                            value="none"
                                        >
                                            <MenuItem className="popup-value-size" disabled value="none" ref="employeeData">
                                                <em>Select Title</em>
                                            </MenuItem>
                                            {this.state.loadTitleTypes.map(function (item, i) {
                                                return <MenuItem className="popup-value-size" value={item.value}>{item.value}</MenuItem>;
                                            })}

                                        </SelectFormsy>

                                        <div className="w-full">

                                        </div>

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 pr-24"
                                            type="text"
                                            name="lastName"
                                            label="Last Name"
                                            // validations={{
                                            //     required: ""
                                            // }}
                                            // validationErrors={{
                                            //     minLength: 'Min character length is 4'
                                            // }}
                                            required
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 pr-24"
                                            type="text"
                                            name="firstName"
                                            label="First Name"
                                            // validations={{
                                            //     required: ""
                                            // }}
                                            // validationErrors={{
                                            //     minLength: 'Min character length is 4'
                                            // }}
                                            required
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 pr-24"
                                            type="text"
                                            name="middleName"
                                            label="Middle Name"
                                        />
                                        <div className="w-full"></div>

                                        <TextFieldFormsy
                                            className="w-full md:w-1/6 mt-16 pr-24"
                                            type="text"
                                            name="nicSsn"
                                            label="NIC No / SSN No"
                                            required
                                        />

                                        <TextFieldFormsy
                                            id="date"
                                            label="Birthday"
                                            name="birthday"
                                            type="date"
                                            defaultValue="2017-05-24"
                                            className="{classes.textField} w-full md:w-1/6 mt-16 pr-24"
                                            required
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />

                                        <div className="w-full md:w-1/3 mt-48">
                                            {/* <label> Gender </label> */}

                                            <label className="md:w-1/3 ml-24 text-lg"><input onChange={this.onGenderChanged('Gen')} className="w-16 h-16" type="radio" name="gender" value="1" />Male</label>
                                            <label className="md:w-1/3 ml-24 text-lg"><input onChange={this.onGenderChanged('Gen')} className="w-16 h-16" type="radio" name="gender" value="2" />Female</label>
                                            <label className="md:w-1/3 ml-24 text-lg"><input onChange={this.onGenderChanged('Gen')} className="w-16 h-16" type="radio" name="gender" value="3" />Other</label>
                                        </div>



                                        {/* <RadioGroupFormsy
                                        horizontal
                                        className="w-full md:w-1/6 mt-16 pr-24"
                                        name="gender"
                                        label="Gender"
                                        // validations="equals:female"
                                        // validationError="Only ladies are accepted"
                                        required
                                    >
                                        <FormControlLabel value="male" control={<Radio color="primary" />} label="Male" />
                                        <FormControlLabel value="female" control={<Radio color="primary" />} label="Female" />
                                        <FormControlLabel value="other" control={<Radio color="primary" />} label="Other" />

                                    </RadioGroupFormsy> */}
                                    </div>
                                </Typography>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel expanded={expanded === 'panel2'} onChange={this.handleChange('panel2')}>
                            <ExpansionPanelSummary className="emp-reg-expand-color-2" expandIcon={<ExpandMoreIcon />}>
                                <Typography className="{classes.heading} flex flex-wrap">Contact Details</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Typography>
                                    <div className="flex flex-wrap -mx-3 mb-6">

                                        <TextFieldFormsy
                                            className="w-full md:w-1/2 pr-24"
                                            type="text"
                                            name="address1"
                                            label="Address line 1"
                                            // validations={{
                                            // required: ""
                                            // }}
                                            // validationErrors={{
                                            //     minLength: 'Min character length is 4'
                                            // }}
                                            required
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/2"
                                            type="text"
                                            name="address2"
                                            label="Address line 2"
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4  mt-24 pr-24"
                                            type="text"
                                            name="state"
                                            label="State"
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4  mt-24 pr-24"
                                            type="text"
                                            name="city"
                                            label="City"
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4  mt-24 pr-24"
                                            type="text"
                                            name="zipCode"
                                            label="Zip Code"
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4  mt-24"
                                            type="text"
                                            name="countryCode"
                                            label="Country Code"
                                        />

                                        {/* <SelectFormsy
                                        className="w-full md:w-1/4  mt-24 pr-24"
                                        name="state"
                                        label="State"
                                        value="none"
                                    >
                                        <MenuItem value="none">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value="mr">1</MenuItem>
                                        <MenuItem value="ms">2</MenuItem>
                                        <MenuItem value="other">3</MenuItem>
                                    </SelectFormsy>

                                    <SelectFormsy
                                        className="w-full md:w-1/4  mt-24 pr-24"
                                        name="city"
                                        label="City"
                                        value="none"
                                    >
                                        <MenuItem value="none">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value="mr">1</MenuItem>
                                        <MenuItem value="ms">2</MenuItem>
                                        <MenuItem value="other">3</MenuItem>
                                    </SelectFormsy>

                                    <SelectFormsy
                                        className="w-full md:w-1/4  mt-24 pr-24"
                                        name="zipCode"
                                        label="Zip Code"
                                        value="none"
                                    >
                                        <MenuItem value="none">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value="mr">1</MenuItem>
                                        <MenuItem value="ms">2</MenuItem>
                                        <MenuItem value="other">3</MenuItem>
                                    </SelectFormsy>

                                    <SelectFormsy
                                        className="w-full md:w-1/4  mt-24 pr-24"
                                        name="countryCode"
                                        label="Country Code"
                                        value="none"
                                    >
                                        <MenuItem value="none">
                                            <em>None</em>

                                        </MenuItem>
                                        <MenuItem value="mr">1</MenuItem>
                                        <MenuItem value="ms">2</MenuItem>
                                        <MenuItem value="other">3</MenuItem>
                                    </SelectFormsy> */}

                                        {/* <PhoneInput
                                        className="w-full md:w-1/4 mt-16 pr-24"
                                        label="Mobile"
                                        placeholder="Enter phone number"
                                        name="mobile"
                                        value={this.state.phone}
                                        onChange={phone => this.setState({ phone })}
                                        required
                                        /> */}

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 mt-16 pr-24"
                                            type="number"
                                            name="mobile"
                                            label="Mobile"
                                            // validations={{
                                            //     required: ""
                                            // }}
                                            // validationErrors={{
                                            //     minLength: 'Min character length is 4'
                                            // }}
                                            required
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 mt-16 pr-24"
                                            type="number"
                                            name="telephone"
                                            label="Telephone"

                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 mt-16 pr-24"
                                            type="number"
                                            name="fax"
                                            label="Fax"

                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 mt-16"
                                            type="text"
                                            name="email"
                                            label="Email"
                                            validations="isEmail"
                                            validationError="This is not a valid email"
                                        // required
                                        />

                                        <div className=" w-full md:w-5/6 mt-16 pr-24"></div>
                                    </div>
                                </Typography>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel expanded={expanded === 'panel3'} onChange={this.handleChange('panel3')}>
                            <ExpansionPanelSummary className="emp-reg-expand-color-3" expandIcon={<ExpandMoreIcon />}>
                                <Typography className="{classes.heading} flex flex-wrap">Salary Details</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Typography>

                                    <div className="flex flex-wrap -mx-3 mb-6">

                                        <TextFieldFormsy
                                            id="date"
                                            label="Appoinment Date"
                                            name="appoinmentDate"
                                            type="date"
                                            defaultValue="2017-05-24"
                                            className="{classes.textField} w-full md:w-1/6 mt-16 pr-24"
                                            required
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />

                                        {/* <TextFieldFormsy
                                        label="Probation Period"
                                        type="number"
                                        name="basicSalary"
                                        id="simple-start-adornment"
                                        className="{classNames(classes.margin, classes.textField)} w-full md:w-1/6 mt-16 pr-24"
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">LKR</InputAdornment>,
                                        }}
                                    /> */}

                                        <TextFieldFormsy
                                            label="Probation Period"
                                            type="number"
                                            name="probationPeriod"
                                            id="simple-start-adornment"
                                            className="{classNames(classes.margin, classes.textField)} w-full md:w-1/6 mt-16 pr-24"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">Months</InputAdornment>,
                                            }}
                                        />

                                        <SelectFormsy
                                            className="w-full md:w-1/4  mt-16 pr-24"
                                            name="department"
                                            label="Department"
                                            value="none"
                                        >
                                            <MenuItem className="popup-value-size" disabled value="none">
                                                <em>Select Depertment</em>
                                                {/* Title */}
                                            </MenuItem>
                                            {this.state.loadDepartmentTypes.map(function (item, i) {
                                                return <MenuItem className="popup-value-size" value={item.value}>{item.value}</MenuItem>;
                                            })}
                                        </SelectFormsy>

                                        <SelectFormsy
                                            className="w-full md:w-1/4  mt-16 pr-24"
                                            name="designation"
                                            label="Designation"
                                            value="none"
                                        >
                                            <MenuItem className="popup-value-size" disabled value="none">
                                                <em>Select Designation</em>
                                                {/* Title */}
                                            </MenuItem>
                                            {this.state.loadDesignationTypes.map(function (item, i) {
                                                return <MenuItem className="popup-value-size" value={item.value}>{item.value}</MenuItem>;
                                            })}
                                        </SelectFormsy>

                                        <SelectFormsy
                                            className="w-full md:w-1/6  mt-16 pr-24"
                                            name="greade"
                                            label="Greade"
                                            value="none"
                                        >
                                            <MenuItem className="popup-value-size" value="none">
                                                <em>None</em>
                                                {/* Title */}
                                            </MenuItem>
                                            {this.state.loadGreads.map(function (item, i) {
                                                return <MenuItem className="popup-value-size" value={item.value}>{item.value}</MenuItem>;
                                            })}
                                        </SelectFormsy>

                                        <SelectFormsy
                                            className="w-full md:w-1/4  mt-16 pr-24"
                                            name="employeement"
                                            label="Employment"
                                            value="none"
                                        >
                                            <MenuItem className="popup-value-size" disabled value="none">
                                                <em>Select Employment Type</em>
                                            </MenuItem>
                                            {this.state.loadEmployementTypes.map(function (item, i) {
                                                return <MenuItem className="popup-value-size" value={item.value}>{item.value}</MenuItem>;
                                            })}
                                        </SelectFormsy>

                                        <SelectFormsy
                                            className="w-full md:w-1/6  mt-16 pr-24"
                                            name="permentShift"
                                            label="Premenent Shift"
                                            value="none"
                                        >
                                            <MenuItem className="popup-value-size" disabled value="none">
                                                <em>Select Shift</em>
                                                {/* Title */}
                                            </MenuItem>
                                            <MenuItem className="popup-value-size" value="day">Day</MenuItem>
                                            <MenuItem className="popup-value-size" value="night">Night</MenuItem>
                                        </SelectFormsy>

                                        <TextFieldFormsy
                                            label="Basic Salary"
                                            type="number"
                                            name="basicSalary"
                                            id="simple-start-adornment"
                                            className="{classNames(classes.margin, classes.textField)} w-full md:w-1/6 mt-16 pr-24"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">LKR</InputAdornment>,
                                            }}
                                        />

                                        <SelectFormsy
                                            className="w-full md:w-1/4  mt-16 pr-24"
                                            name="paymentMethod"
                                            label="Payment Method"
                                            value="none"
                                        >
                                            <MenuItem className="popup-value-size" disabled value="none">
                                                <em>Select Payemt Type</em>
                                                {/* Title */}
                                            </MenuItem>
                                            {this.state.loadPaymentTypes.map(function (item, i) {
                                                return <MenuItem className="popup-value-size" value={item.value}>{item.value}</MenuItem>;
                                            })}
                                        </SelectFormsy>

                                        <SelectFormsy
                                            className="w-full md:w-1/6  mt-16 pr-24"
                                            name="timeCategory"
                                            label="Time Category"
                                            value="none"
                                        >
                                            <MenuItem className="popup-value-size" disabled value="none">
                                                <em>Select Time</em>
                                            </MenuItem>
                                            {this.state.loadTimeCategoryTypes.map(function (item, i) {
                                                return <MenuItem className="popup-value-size" value={item.value}>{item.value}</MenuItem>;
                                            })}
                                        </SelectFormsy>

                                        {/* <div className="w-full md:w-1/3  mt-16 pr-24"></div> */}
                                        {/* <div className="w-full"> */}

                                        <div className="md:w-1/2 mt-12 border-solid border-1 rounded border-grey bg-grey-lightest pr-24 ">
                                            <div >
                                                <h6 className="mt-16 ml-8">Allowance</h6>
                                            </div>
                                            <div className="w-full pr-24">
                                                {this.state.inputsAdd.map(inputAdd =>

                                                    <div className="w-full" id={"allow" + inputAdd}>

                                                        <SelectFormsy
                                                            className="w-full md:w-1/3 mt-16 pr-24 ml-8 "
                                                            id={"additionType" + inputAdd}
                                                            name={"additionType" + inputAdd}
                                                            label={"Addition Type " + inputAdd}
                                                            value={"none"}
                                                        >
                                                            <MenuItem className="popup-value-size" disabled value="none">
                                                                <em>None</em>
                                                            </MenuItem>
                                                            <MenuItem className="popup-value-size" value="mobile">Mobile</MenuItem>
                                                            <MenuItem className="popup-value-size" value="travaling">Travaling</MenuItem>
                                                            <MenuItem className="popup-value-size" value="meal">Meal</MenuItem>
                                                        </SelectFormsy>

                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/3 mt-16"
                                                            id={"additionValue" + inputAdd}
                                                            type="number"
                                                            name={"addtionValue" + inputAdd}
                                                            label={"Addition Value " + inputAdd}
                                                            value=""

                                                        />

                                                        {/* <IconButton style={{ marginLeft: 'auto', height: '38px' }} */}
                                                        <IconButton style={alDuStyle(inputAdd)}
                                                            title="Remove Allowance Type"
                                                            onClick={() => this.removeAllows(inputAdd)}

                                                        >
                                                            <Icon className="text-red-light">delete</Icon>
                                                        </IconButton>
                                                    </div>

                                                )}

                                            </div>
                                            <div className="w-full">
                                                <Button type="button" onClick={() => this.appendInputAdd()} variant="fab" mini color="secondary" aria-label="add" className="mt-8 ml-8">
                                                    <AddIcon />
                                                </Button>
                                            </div>

                                        </div>
                                        <div className="md:w-1/2 mt-12 border-solid border-1 rounded border-grey bg-grey-lightest pr-24">
                                            <div >
                                                <h6 className="mt-16 ml-8">Deduction</h6>
                                            </div>
                                            {/* <div className=" md:w-1/2 "> */}
                                            {this.state.inputsDedu.map(inputDedu =>

                                                <div className="w-full" id={"dedu" + inputDedu}>

                                                    <SelectFormsy
                                                        className="w-full md:w-1/3  mt-16 pr-24 ml-8"
                                                        id={"diductionType" + inputDedu}
                                                        name={"diductionType" + inputDedu}
                                                        label={"Deduction Type "}
                                                        value={"none"}
                                                    >
                                                        <MenuItem className="popup-value-size" disabled value="none">
                                                            <em>None</em>
                                                            {/* Title */}
                                                        </MenuItem>
                                                        <MenuItem className="popup-value-size" value="mobile">Mobile</MenuItem>
                                                        <MenuItem className="popup-value-size" value="travaling">Travaling</MenuItem>
                                                        <MenuItem className="popup-value-size" value="meal">Meal</MenuItem>
                                                    </SelectFormsy>

                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/3 mt-16"
                                                        id={"deductionValue" + inputDedu}
                                                        type="number"
                                                        name={"deductionValue" + inputDedu}
                                                        label={"Deduction Value "}
                                                        value=""

                                                    />
                                                    <IconButton style={alDuStyle(inputDedu)}
                                                        title="Remove Deduction Type"
                                                        onClick={() => this.removeDeductions(inputDedu)}

                                                    >
                                                        <Icon className="text-red-light">delete</Icon>
                                                    </IconButton>

                                                </div>
                                            )}
                                            {/* </div> */}
                                            <div className="">
                                                <Button type="button" onClick={() => this.appendInputDedu()} variant="fab" mini color="secondary" aria-label="add" className="mt-8 ml-8">
                                                    <AddIcon />
                                                </Button>
                                            </div>
                                        </div>

                                        {/* </div> */}


                                        {/* <div className="w-full md:w-1/3"></div> */}

                                        {/* <Button type="button" variant="raised" size="small" color="primary" className="{classes.button} w-full md:w-1/6 md:h-24 mt-16 pr-24">
                                        Black List
                                    </Button> */}

                                        {/* <div className="w-full md:w-1/6"></div> */}

                                        {/* <label className="md:w-1/6 mt-32 text-lg"><input className="w-16 h-16" onChange={this.onEmpStatusChanged('Sus')} type="radio" name="empStatus" value="suspend" />Suspend</label> */}

                                        {/* <div className="w-full md:w-1/6"></div> */}

                                        {/* <label className="md:w-1/6 mt-32 text-lg"><input className="w-16 h-16" onChange={this.onEmpStatusChanged('Act')} checked type="radio" name="empStatus" value="active" />Active</label> */}

                                        <div className="w-full md:w-1/6"></div>
                                    </div>

                                </Typography>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel expanded={expanded === 'panel4'} onChange={this.handleChange('panel4')}>
                            <ExpansionPanelSummary className="emp-reg-expand-color-4" expandIcon={<ExpandMoreIcon />}>
                                <Typography className="{classes.heading} flex flex-wrap">User Account</Typography>
                                {/* <Typography className={classes.secondaryHeading}>I am an expansion panel</Typography> */}
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Typography className="w-full">

                                    <SelectFormsy
                                        className="w-full md:w-1/5 pr-24"
                                        name="employeeRoll"
                                        label="Employee Role"
                                        value="none"
                                        required
                                    >
                                        <MenuItem className="popup-value-size" disabled value="none">
                                            <em>Select Employee Role </em>
                                        </MenuItem>
                                        <MenuItem className="popup-value-size" value="admin">Admin</MenuItem>
                                        <MenuItem className="popup-value-size" value="supervisor">Supervisor</MenuItem>
                                        <MenuItem className="popup-value-size" value="user">User</MenuItem>
                                    </SelectFormsy>
                                    <div className="w-full md:w-4/5"></div>

                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 mt-16 pr-8"
                                        type="text"
                                        name="userName"
                                        label="UserName"
                                        required
                                    />

                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 mt-16"
                                        type="password"
                                        name="password"
                                        label="Password"
                                        validations={{
                                            minLength: 4
                                        }}
                                        validationErrors={{
                                            minLength: 'Min character length is 4'
                                        }}
                                        required
                                    />
                                    {/* <div className="w-full md:w-1/4 pr-24"> */}
                                    <FormControlLabel
                                        className="ml-16 mt-8"
                                        control={
                                            <Checkbox
                                                checked={this.state.empStatus}
                                                // onChange={this.handleCheckSuspendChange('isSuspend')}
                                                onChange={this.onEmpStatusChanged('Act')}
                                                // checked
                                                disabled
                                                color="primary"
                                            />
                                        }
                                        label="Active"
                                    />


                                    {/* checked */}


                                    {/* <label className="md:w-1/6 mt-48 ml-32 pt-48 text-lg"><input className=" w-16 h-16 mt-48 pt-48" onChange={this.onEmpStatusChanged('Act')} type="radio" name="empStatus" value="active" />Active</label> */}
                                    <div className="w-full md:w-2/3"></div>

                                    <div className="w-full md:w-1/3 float-right mb-16">
                                        {/* onClick={this.saveEmployee.bind(this)} */}
                                        <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/3 md:h-24 mt-16 pr-24 -ml-24 mr-8">
                                            Save
                                        </Button>

                                        <Button type="button" onClick={this.resetForm} variant="raised" size="small" className="{classes.button} w-full md:w-1/3 md:h-24 mt-16 pr-24 mr-8">
                                            Clear
                                        </Button>

                                        {/* <Button type="button" variant="raised" size="small" color="primary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 pr-24 mr-8">
                                        Close
                                    </Button> */}

                                        <Button type="button" variant="raised" size="small" color="primary" className="{classes.button} w-full md:w-1/3 md:h-24 mt-16 pr-24">
                                            Help
                                        </Button>
                                    </div>

                                </Typography>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                    </Formsy>
                </div >
            )
        }
    }

}

export default withStyles(styles, { withTheme: true })(withAlert(Tab1GeneralDetails));


// WEBPACK FOOTER //
// ./src/main/content/hr/createEmployee/components/Tab1GeneralDetails.js